import { FC21Lobby } from '../models/fc21lobby';
import { FCBLobby } from '../models/fcblobby';
/**
 * Created by karthikeyan.k on 27-11-2018.
 */
export class LobbyConstant {
  public static get FC21(): Array<FC21Lobby> {
    const gameFC21Arr: Array<FC21Lobby> = [
      <FC21Lobby>{
        game: 'fcg21ornothing',
        gameType: 'livedealer',
        gameName: 'fc21',
        tableType: 'multiplayer',
        featureName: 'livedealer',
        langCode: 'LANG00128',
        gameLangCode: 'LANG00126',
        imageName: 'livedealer_fc21',
        iconName: 'livedealer_icon',
        overImageName: 'livedealer_fc21_hover',
        underlayImageName: '5H_fc21_5H_live_dealer_overlay@2x',
        overlayImageName: 'fc21_7H_live_dealer_overlay@2x',
        isPrivate: false,
        players: '1~7',
        betlimitId: 1,
        bets: '1~7',
        tableLimits: '$5-$1000',
        decks: '8',
        seat: '7',
        shuffles: '100%',
        splits: '5-9',
        soft17: false,
        maxbet: 1000,
        minbet: 5,
        supernatural: '2:1 / 200%',
        naturaltwentyone: '3:2 / 150%',
        doublenatural: '1:1 / 100%',
        naturalzero: '1:1 / 100%',
        colorcardinsurance: '2:1 / 200%',
        whitecardinsurance: '2:1 / 200%',
        russianroulette17: '6:5 / 120%',
        russianroulette18: '7:5 / 140%',
        russianroulette19: '2:1 / 200%',
        russianroulette20: '7:2 / 350%',
      },
      <FC21Lobby>{
        game: 'fcg21ornothing',
        gameType: 'rng',
        gameName: 'fc21',
        tableType: 'multiplayer',
        featureName: 'livecasino',
        langCode: 'LANG00129',
        gameLangCode: 'LANG00126',
        imageName: 'livecasino_fc21',
        iconName: 'livecasino_icon',
        overImageName: 'livecasino_fc21_hover',
        underlayImageName: '5H_select_a_table_underlay@2x',
        overlayImageName: 'fc21_5H_live_casino_overlay@2x',
        isPrivate: false,
        players: '1~5',
        betlimitId: 1,
        bets: '1~5',
        tableLimits: '$5-$1000',
        decks: '8',
        seat: '5',
        shuffles: '100%',
        splits: '5-9',
        soft17: true,
        maxbet: 1000,
        minbet: 5,
        supernatural: '2:1 / 200%',
        naturaltwentyone: '3:2 / 150%',
        doublenatural: '1:1 / 100%',
        naturalzero: '1:1 / 100%',
        colorcardinsurance: '2:1 / 200%',
        whitecardinsurance: '2:1 / 200%',
        russianroulette17: '6:5 / 120%',
        russianroulette18: '7:5 / 140%',
        russianroulette19: '2:1 / 200%',
        russianroulette20: '7:2 / 350%',
      },
      <FC21Lobby>{
        game: 'fcg21ornothing',
        gameType: 'rng',
        gameName: 'fc21',
        tableType: 'privatetable',
        featureName: 'private',
        langCode: 'LANG00130',
        gameLangCode: 'LANG00126',
        imageName: 'private_fc21',
        iconName: 'private_icon',
        overImageName: 'private_fc21_hover',
        underlayImageName: '5H_select_a_table_underlay@2x',
        overlayImageName: 'fc21_5H_private_table_overlay@2x',
        isPrivate: true,
        players: '1',
        betlimitId: 1,
        bets: '1~5',
        tableLimits: '$5-$1000',
        decks: '8',
        seat: '5',
        shuffles: '100%',
        splits: '5-9',
        soft17: true,
        maxbet: 1000,
        minbet: 5,
        supernatural: '2:1 / 200%',
        naturaltwentyone: '3:2 / 150%',
        doublenatural: '1:1 / 100%',
        naturalzero: '1:1 / 100%',
        colorcardinsurance: '2:1 / 200%',
        whitecardinsurance: '2:1 / 200%',
        russianroulette17: '6:5 / 120%',
        russianroulette18: '7:5 / 140%',
        russianroulette19: '2:1 / 200%',
        russianroulette20: '7:2 / 350%',
      },
      <FC21Lobby>{
        game: 'fcg21ornothing',
        gameType: 'rng',
        gameName: 'fc21',
        tableType: 'privatetablefriends',
        featureName: 'privatefriends',
        langCode: 'LANG00131',
        gameLangCode: 'LANG00126',

        imageName: 'privatefriends_fc21',
        iconName: 'privatefriends_icon',
        overImageName: 'privatefriends_fc21_hover',
        underlayImageName: '5H_select_a_table_underlay@2x',
        overlayImageName: 'fc21_5H_private_table+_overlay@2x',
        isPrivate: true,
        players: '1+4',
        betlimitId: 1,
        bets: '1~5',
        tableLimits: '$5-$1000',
        decks: '8',
        seat: '5',
        shuffles: '100%',
        splits: '5-9',
        soft17: true,
        maxbet: 1000,
        minbet: 5,
        supernatural: '2:1 / 200%',
        naturaltwentyone: '3:2 / 150%',
        doublenatural: '1:1 / 100%',
        naturalzero: '1:1 / 100%',
        colorcardinsurance: '2:1 / 200%',
        whitecardinsurance: '2:1 / 200%',
        russianroulette17: '6:5 / 120%',
        russianroulette18: '7:5 / 140%',
        russianroulette19: '2:1 / 200%',
        russianroulette20: '7:2 / 350%',
      },
    ];
    return gameFC21Arr;
  }

  public static get MOBLEFC21(): Array<FC21Lobby> {
    const gameFC21Arr: Array<FC21Lobby> = [
      <FC21Lobby>{
        game: 'fcg21ornothing',
        gameType: 'livedealer',
        gameName: 'fc21',
        tableType: 'multiplayer',
        featureName: 'livedealer',
        langCode: 'LANG00128',
        gameLangCode: 'LANG00126',

        imageName: 'livedealer_fc21',
        iconName: 'livedealer_icon',
        overImageName: 'livedealer_fc21_hover',
        underlayImageName: '5H_fc21_5H_live_dealer_overlay@2x',
        overlayImageName: 'fc21_7H_live_dealer_overlay@2x',
        isPrivate: false,
        players: '1~7',
        betlimitId: 1,
        bets: '1~7',
        tableLimits: '$5-$1000',
        decks: '8',
        seat: '7',
        shuffles: '100%',
        splits: '5-9',
        soft17: false,
        maxbet: 1000,
        minbet: 5,
        supernatural: '2:1 / 200%',
        naturaltwentyone: '3:2 / 150%',
        doublenatural: '1:1 / 100%',
        naturalzero: '1:1 / 100%',
        colorcardinsurance: '2:1 / 200%',
        whitecardinsurance: '2:1 / 200%',
        russianroulette17: '6:5 / 120%',
        russianroulette18: '7:5 / 140%',
        russianroulette19: '2:1 / 200%',
        russianroulette20: '7:2 / 350%',
      },
      <FC21Lobby>{
        game: 'fcg21ornothing',
        gameType: 'rng',
        gameName: 'fc21',
        tableType: 'multiplayer',
        featureName: 'livecasino',
        langCode: 'LANG00129',
        gameLangCode: 'LANG00126',

        imageName: 'livecasino_fc21',
        iconName: 'livecasino_icon',
        overImageName: 'livecasino_fc21_hover',
        underlayImageName: '5H_select_a_table_underlay@2x',
        overlayImageName: 'fc21_5H_live_casino_overlay@2x',
        isPrivate: false,
        players: '1~5',
        betlimitId: 1,
        bets: '1~5',
        tableLimits: '$5-$1000',
        decks: '8',
        seat: '5',
        shuffles: '100%',
        splits: '5-9',
        soft17: true,
        maxbet: 1000,
        minbet: 5,
        supernatural: '2:1 / 200%',
        naturaltwentyone: '3:2 / 150%',
        doublenatural: '1:1 / 100%',
        naturalzero: '1:1 / 100%',
        colorcardinsurance: '2:1 / 200%',
        whitecardinsurance: '2:1 / 200%',
        russianroulette17: '6:5 / 120%',
        russianroulette18: '7:5 / 140%',
        russianroulette19: '2:1 / 200%',
        russianroulette20: '7:2 / 350%',
      },
      <FC21Lobby>{
        game: 'fcg21ornothing',
        gameType: 'rng',
        gameName: 'fc21',
        tableType: 'privatetable',
        featureName: 'private',
        langCode: 'LANG00130',
        gameLangCode: 'LANG00126',

        imageName: 'private_fc21_2',
        iconName: 'private_icon',
        overImageName: 'private_fc21_2_hover',
        underlayImageName: '2H+3H_fc21_select_a_table_underlay@2x',
        overlayImageName: 'fc21_2H_private_table_overlay@2x',
        isPrivate: true,
        players: '1',
        betlimitId: 1,
        bets: '1~5',
        tableLimits: '$5-$1000',
        decks: '8',
        seat: '2',
        shuffles: '100%',
        splits: '5-9',
        soft17: true,
        maxbet: 1000,
        minbet: 5,
        supernatural: '2:1 / 200%',
        naturaltwentyone: '3:2 / 150%',
        doublenatural: '1:1 / 100%',
        naturalzero: '1:1 / 100%',
        colorcardinsurance: '2:1 / 200%',
        whitecardinsurance: '2:1 / 200%',
        russianroulette17: '6:5 / 120%',
        russianroulette18: '7:5 / 140%',
        russianroulette19: '2:1 / 200%',
        russianroulette20: '7:2 / 350%',
      },
      <FC21Lobby>{
        game: 'fcg21ornothing',
        gameType: 'rng',
        gameName: 'fc21',
        tableType: 'privatetablefriends',
        featureName: 'privatefriends',
        langCode: 'LANG00131',
        gameLangCode: 'LANG00126',

        imageName: 'privatefriends_fc21',
        iconName: 'privatefriends_icon',
        overImageName: 'privatefriends_fc21_hover',
        underlayImageName: '5H_select_a_table_underlay@2x',
        overlayImageName: 'fc21_5H_private_table+_overlay@2x',
        isPrivate: true,
        players: '1+4',
        betlimitId: 1,
        bets: '1~5',
        tableLimits: '$5-$1000',
        decks: '8',
        seat: '5',
        shuffles: '100%',
        splits: '5-9',
        soft17: true,
        maxbet: 1000,
        minbet: 5,
        supernatural: '2:1 / 200%',
        naturaltwentyone: '3:2 / 150%',
        doublenatural: '1:1 / 100%',
        naturalzero: '1:1 / 100%',
        colorcardinsurance: '2:1 / 200%',
        whitecardinsurance: '2:1 / 200%',
        russianroulette17: '6:5 / 120%',
        russianroulette18: '7:5 / 140%',
        russianroulette19: '2:1 / 200%',
        russianroulette20: '7:2 / 350%',
      },
      <FC21Lobby>{
        game: 'fcg21ornothing',
        gameType: 'rng',
        gameName: 'fc21',
        tableType: 'privatetable',
        featureName: 'private',
        langCode: 'LANG00130',
        gameLangCode: 'LANG00126',

        imageName: 'private_fc21_3',
        iconName: 'private_icon',
        overImageName: 'private_fc21_3_hover',
        underlayImageName: '2H+3H_fc21_select_a_table_underlay@2x',
        overlayImageName: 'fc21_3H_private_table_overlay@2x',
        isPrivate: true,
        players: '1',
        betlimitId: 1,
        bets: '1~5',
        tableLimits: '$5-$1000',
        decks: '8',
        seat: '3',
        shuffles: '100%',
        splits: '5-9',
        soft17: true,
        maxbet: 1000,
        minbet: 5,
        supernatural: '2:1 / 200%',
        naturaltwentyone: '3:2 / 150%',
        doublenatural: '1:1 / 100%',
        naturalzero: '1:1 / 100%',
        colorcardinsurance: '2:1 / 200%',
        whitecardinsurance: '2:1 / 200%',
        russianroulette17: '6:5 / 120%',
        russianroulette18: '7:5 / 140%',
        russianroulette19: '2:1 / 200%',
        russianroulette20: '7:2 / 350%',
      },
      <FC21Lobby>{
        game: 'fcg21ornothing',
        gameType: 'rng',
        gameName: 'fc21',
        tableType: 'privatetable',
        featureName: 'private',
        langCode: 'LANG00130',
        gameLangCode: 'LANG00126',

        imageName: 'private_fc21',
        iconName: 'private_icon',
        overImageName: 'private_fc21_hover',
        underlayImageName: '5H_select_a_table_underlay@2x',
        overlayImageName: 'fc21_5H_private_table_overlay@2x',
        isPrivate: true,
        players: '1',
        betlimitId: 1,
        bets: '1~5',
        tableLimits: '$5-$1000',
        decks: '8',
        seat: '5',
        shuffles: '100%',
        splits: '5-9',
        soft17: true,
        maxbet: 1000,
        minbet: 5,
        supernatural: '2:1 / 200%',
        naturaltwentyone: '3:2 / 150%',
        doublenatural: '1:1 / 100%',
        naturalzero: '1:1 / 100%',
        colorcardinsurance: '2:1 / 200%',
        whitecardinsurance: '2:1 / 200%',
        russianroulette17: '6:5 / 120%',
        russianroulette18: '7:5 / 140%',
        russianroulette19: '2:1 / 200%',
        russianroulette20: '7:2 / 350%',
      },
    ];
    return gameFC21Arr;
  }
  public static get FCB(): Array<FCBLobby> {
    const gameFCBArr: Array<FCBLobby> = [
      <FCBLobby>{
        game: 'fcgbaccarat',
        gameType: 'livedealer',
        gameName: 'fcb',
        tableType: 'privatetable',
        featureName: 'livedealer',
        langCode: 'LANG00128',
        gameLangCode: 'LANG00127',

        imageName: 'livedealer_fcb',
        iconName: 'livedealer_icon',
        overImageName: 'livedealer_fcb_hover',
        underlayImageName: 'all_fcb_live_dealer_underlay',
        overlayImageName: '_fcb_live_dealer_overlay',
        isPrivate: false,
        players: '∞',
        betlimitId: 1,
        bets: '1',
        tableLimits: '$5-$1000',
        maxbet: 1000,
        minbet: 5,
        decks: '8',
        seat: '1',
        shuffles: '50%',
        commission: '5%',
        tie: '2:1 / 200%',
        minustwo: '1:1 / 100%',
        plustwo: '1:1 / 100%',
        minusthree: '5:1 / 500%',
        plusthree: '3:1 / 300%',
      },
      <FCBLobby>{
        game: 'fcgbaccarat',
        gameType: 'rng',
        gameName: 'fcb',
        tableType: 'multiplayer',
        featureName: 'livecasino',
        langCode: 'LANG00129',
        gameLangCode: 'LANG00127',

        imageName: 'livecasino_fcb',
        iconName: 'livecasino_icon',
        overImageName: 'livecasino_fcb_hover',
        underlayImageName: 'all_fcb_select_a_table_underlay@2x',
        overlayImageName: '_fcb_lc_select_a_table_overlay@2x',
        isPrivate: false,
        players: '∞',
        betlimitId: 1,
        bets: '1',
        tableLimits: '$5-$1000',
        maxbet: 1000,
        minbet: 5,
        decks: '8',
        seat: '1',
        shuffles: '50%',
        commission: '5%',
        tie: '2:1 / 200%',
        minustwo: '1:1 / 100%',
        plustwo: '1:1 / 100%',
        minusthree: '5:1 / 500%',
        plusthree: '3:1 / 300%',
      },
      <FCBLobby>{
        game: 'fcgbaccarat',
        gameType: 'rng',
        gameName: 'fcb',
        tableType: 'privatetable',
        featureName: 'private',
        langCode: 'LANG00130',
        gameLangCode: 'LANG00127',

        imageName: 'private_fcb',
        iconName: 'private_icon',
        overImageName: 'private_fcb_hover',
        underlayImageName: 'all_fcb_select_a_table_underlay@2x',
        overlayImageName: '_fcb_pt_select_a_table_overlay@2x',
        isPrivate: true,
        players: '1',
        betlimitId: 1,
        bets: '1',
        tableLimits: '$5-$1000',
        maxbet: 1000,
        minbet: 5,
        decks: '8',
        seat: '1',
        shuffles: '50%',
        commission: '5%',
        tie: '2:1 / 200%',
        minustwo: '1:1 / 100%',
        plustwo: '1:1 / 100%',
        minusthree: '5:1 / 500%',
        plusthree: '3:1 / 300%',
      },
      <FCBLobby>{
        game: 'fcgbaccarat',
        gameType: 'rng',
        tableType: 'privatetablefriends',
        gameName: 'fcb',
        featureName: 'privatefriends',
        langCode: 'LANG00131',
        gameLangCode: 'LANG00127',

        imageName: 'privatefriends_fcb',
        iconName: 'privatefriends_icon',
        overImageName: 'privatefriends_fcb_hover',
        underlayImageName: 'all_fcb_select_a_table_underlay@2x',
        overlayImageName: '_fcb_pt+_select_a_table_overlay@2x',
        isPrivate: false,
        players: '1+4',
        betlimitId: 1,
        bets: '1',
        tableLimits: '$5-$1000',
        maxbet: 1000,
        minbet: 5,
        decks: '8',
        seat: '1',
        shuffles: '50%',
        commission: '5%',
        tie: '2:1 / 200%',
        minustwo: '1:1 / 100%',
        plustwo: '1:1 / 100%',
        minusthree: '5:1 / 500%',
        plusthree: '3:1 / 300%',
      },
    ];
    return gameFCBArr;
  }
}
